export const isServer = (): boolean => typeof window === 'undefined';
export type IsServer = typeof isServer;
